// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ButtonCross_wrapper__2iaIq","close":"ButtonCross_close__TSDba"};